// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from '@/App'
import router from '@/router'
import VModal from 'vue-js-modal'
import eventBus from '@/Common/EventBus'
import Utility from '@/Common/Utility'
import ApiService from '@/Common/ApiService'
import Sklc from '@/Common/Sklc'
import Configuration from '@/Common/Configuration'
import Loading from '@/Controls/Loading'
import paging from '@/Controls/Paging'
import tw from '@/lang/tw'
import en from '@/lang/en'
import VueCookies from 'vue-cookies'
import KeyCode from '@/Common/KeyCode'
import BuildInFunctions from '@/Common/BuildInFunctions'
import ControlBase from '@/Common/ControlBase'
import VueI18n from 'vue-i18n'
import VueResource from 'vue-resource';
import { ShoppingCart, ShoppingCartProduct } from "@/Common/ShoppingCart";
import TControls from '@/Common/TControls'
import BlockPagingAnchor from '@/PlugableControls/BlockPagingAnchor';
import ConfirmDialog from '@/Dialogs/ConfirmDialog';
import vuetify from '@/plugins/vuetify';// path to vuetify export



Vue.config.productionTip = false;

Vue.config.ignoredElements = ["control"];



Vue.use(VueResource);
Vue.use(VueI18n);

Vue.component("t-loading", Loading);
Vue.component("paging", paging);
Vue.component("BlockPagingAnchor", BlockPagingAnchor);
Vue.component("ConfirmDialog", ConfirmDialog);


//取得預設語系
const locale = localStorage.getItem('locale') || 'tw'


//建立 VueI18n 實體
const i18n = new VueI18n({
    locale,
    messages: { tw: tw }
})

//export default i18n;
 

if (typeof (AppSettings) != "undefined" && typeof (AppSettings) == "object") {
    Configuration.BaseUrl = AppSettings.BaseUrl;
    window["BaseUrl"] = AppSettings.BaseUrl;
    window["HostName"] = AppSettings.HostName;
}


Vue.use(VModal);
//Vue.use(MyPlugin);
Vue.use(ControlBase);
Vue.use(VueCookies);
//Vue.use(moment);

Vue.use(Utility);
Vue.use(ApiService);

Vue.use(Sklc);

Vue.use(BuildInFunctions);

Vue.use(TControls);


Vue.filter("Currency",
    function (amount, decimalCount = 0, decimal = ".", thousands = ",") {
        try {
            let formattedAmount = "";

            if (amount == "" || isNaN(amount)) {
                return amount;
            }

            decimalCount = Math.abs(decimalCount);
            decimalCount = isNaN(decimalCount) ? 2 : decimalCount;

            const negativeSign = amount < 0 ? "-" : "";

            let i = parseInt(amount = Math.abs(Number(amount) || 0).toFixed(decimalCount)).toString();
            let j = (i.length > 3) ? i.length % 3 : 0;

            formattedAmount = negativeSign + (j ? i.substr(0, j) + thousands : '') + i.substr(j).replace(/(\d{3})(?=\d)/g, "$1" + thousands) + (decimalCount ? decimal + Math.abs(amount - i).toFixed(decimalCount).slice(2) : "");

            return formattedAmount;
        } catch (e) {
            console.log(e);
        }
    }
);

window["VF"] = Vue;

//Vue.config.ignoredElements = [/Faq/i, /FaqItemList/i, /Description/i,/control/i];
Vue.config.ignoredElements = [/[a-z]+/i];

/* eslint-disable no-new */
new Vue(
    {
        el: '#app',
        data() {
            return {
                // Bind our event bus to our $root Vue model
                bus: eventBus,
                ID: "ID1",
            }
        },
         
        created() {
            window["vueComponent"] = this;

            window["RouteTo"] = function (url) {
                window["vueComponent"].$router.push(url);
            };
        },
        vuetify, // add by VYHU
        router,
        render(h) {
            return h('App');
        },

        i18n,
        components: { App },
        //template: '<App/>'
    }
);

